export interface IStorageListHeader {
  onIsBringBackChange: (val: boolean) => void;
  searchQueryChange: (val: string) => void;
  onIsFilterOpenChange: (val: boolean) => void;
  isFilterOpen: boolean;
  hasValues?: boolean;
  handleReset: () => void;
  handleExport?: (includeImages: boolean) => void;
  data?: { results: any[]; totalCount?: number } | undefined; // Storage data for select all functionality
  searchVal?: string;
  filters?: Record<string, string | null>;
  filterQueries?: any[];
  selectedStorageIds: number[];
  uniqueCustomFieldLabels?: string[];
  onBulkEditSuccess: () => void;
}

export enum ViewType {
  GRID = "grid",
  LIST = "list",
}
